import {BUSINESS_CATEGORIES_GROUPED} from '../constants';
import {BizLookingFor, BizServiceArea, BizSize} from '../models/business-directory';

export const SERVICE_AREAS: { value: BizServiceArea; label: string }[] = [
    {value: 'LOCAL', label: 'Local (my city / area)'},
    {value: 'REGIONAL', label: 'Regional (my state / region)'},
    {value: 'NATIONAL', label: 'Nationwide'},
    {value: 'ONLINE', label: 'Online only'},
];

export const BIZ_SIZES: { value: BizSize; label: string }[] = [
    {value: 'SOLO', label: 'Just me'},
    {value: 'SMALL', label: '2 - 10 people'},
    {value: 'MEDIUM', label: '11 - 50 people'},
    {value: 'LARGE', label: 'More than 50'},
];

export const LOOKING_FOR: { value: BizLookingFor; label: string }[] = [
    {value: 'CUSTOMERS', label: 'Customers'},
    {value: 'PARTNERS', label: 'Partners'},
    {value: 'INVESTORS', label: 'Investors'},
    {value: 'EMPLOYEES', label: 'Employees'},
    {value: 'MENTORS', label: 'Mentors'},
    {value: 'SUPPLIERS', label: 'Suppliers'},
];

export function serviceAreaLabel(value?: string): string {
    return SERVICE_AREAS.find(a => a.value === value)?.label.split(' (')[0] || '';
}

export function sizeLabel(value?: string): string {
    return BIZ_SIZES.find(s => s.value === value)?.label || '';
}

export function lookingForLabel(value: string): string {
    return LOOKING_FOR.find(l => l.value === value)?.label || value;
}

/** Display name for a stored category code; an unknown code is shown as-is. */
export function categoryName(code?: string): string {
    if (!code) return '';
    for (const group of BUSINESS_CATEGORIES_GROUPED) {
        const found = group.categories.find(c => c.code === code);
        if (found) return found.name;
    }
    return code;
}

export function categoryGroupOf(code?: string): string {
    return BUSINESS_CATEGORIES_GROUPED.find(g => g.categories.some(c => c.code === code))?.group || '';
}

export function groupCodes(groupName: string): string[] {
    return BUSINESS_CATEGORIES_GROUPED.find(g => g.group === groupName)?.categories.map(c => c.code) || [];
}

export function initialsOf(name?: string): string {
    const parts = (name || '').trim().split(/\s+/).filter(p => p);
    return ((parts[0]?.charAt(0) || '') + (parts[1]?.charAt(0) || '')).toUpperCase() || '?';
}
